import { render } from "./SponsorsComponent.vue?vue&type=template&id=31e6d7e1"
import script from "./SponsorsComponent.vue?vue&type=script&lang=js"
export * from "./SponsorsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__